module.exports = __webpack_public_path__ + "img/Play_Store_Download.a3e1153d.png";